// --------------------------------------------------------------
// Created On: 2021-09-21
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Modal from "react-bootstrap/Modal";

// Generic modal footer.
export default function ModalFooter(props: Props): Component {
  return (
    <Modal.Footer data-test="modal-footer" className={props.className || undefined}>
      {props.children}
    </Modal.Footer>
  );
}

interface Props {
  className?: string;
  children?: Children;
}
